import { RJSFValidationError } from "@rjsf/utils";

export const transformErrors = (errors: RJSFValidationError[]) => {

  return errors.map((error) => {
    if (error.name === "pattern") {
      error.message = "Alleen cijfers zijn toegestaan";
    }
    if (error.name === "required") {
      error.message = "Dit veld is verplicht";
    }
    if (error.name === "enum") {
      if(error.params.allowedValues.length === 1 && error.params.allowedValues[0] === true){
        error.message = "Je moet dit veld aanvinken om verder te gaan";
      } else {
        error.message = "Zorg ervoor dat alle vragen met betrekking tot deze vraag beantwoord zijn";
      }
    }
    if (error.name === "type") {
      if (error.message === "must be string") {
        error.message = "Dit veld moet een tekst zijn";
      } else if (error.message === "must be number") {
        error.message = "Dit veld moet een getal zijn. In het geval van decimalen, gebruik een punt in plaats van een komma";
      } else if (error.message === "must be object") {
        error.message =
          "Vul de verplichte velden in of verwijder de velden met de verwijderknop";
      }
      else {
        error.message = ('Er gaat iets fout: '+ error.message )
      }
    }
    if (error.name === "const" || error.name === "oneOf") {
      error.message = "Dit veld is verplicht";
    }
    return error;
  });
}